<template>
    <v-menu offset-y left>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                small
                depressed
                color="white"
                class="team-calendar-btn"
                title="Το πρόγραμμα της ομάδας στο ημερολόγιό σου, με αυτόματες αλλαγές"
                v-bind="attrs"
                v-on="on"
            >
                <v-icon small left color="orange darken-2">mdi-calendar-sync</v-icon>
                Πρόγραμμα στο ημερολόγιο
            </v-btn>
        </template>
        <v-list dense class="team-calendar-menu">
            <v-subheader class="team-calendar-menu__hint">
                Συνδρομή: οι αγώνες και κάθε αλλαγή τους μπαίνουν αυτόματα
            </v-subheader>
            <v-list-item @click="subscribeApple">
                <v-list-item-icon><v-icon>mdi-apple</v-icon></v-list-item-icon>
                <v-list-item-title>iPhone / Mac / Outlook</v-list-item-title>
            </v-list-item>
            <v-list-item @click="subscribeGoogle">
                <v-list-item-icon><v-icon>mdi-google</v-icon></v-list-item-icon>
                <v-list-item-title>Google Calendar (και Android)</v-list-item-title>
            </v-list-item>
            <v-list-item @click="copyLink">
                <v-list-item-icon><v-icon>{{ copied ? 'mdi-check' : 'mdi-link-variant' }}</v-icon></v-list-item-icon>
                <v-list-item-title>{{ copied ? 'Αντιγράφηκε' : 'Αντιγραφή συνδέσμου' }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
    // Subscription to the calendar of a team (GET teams/{id}/calendar.ics): unlike adding one match,
    // the calendar app fetches it again now and then, so new matches and changes of time or arena show up by themselves
    export default {
        name: 'TeamCalendarButton',
        props: {
            teamId: {
                type: [Number, String],
                required: true
            }
        },
        data() {
            return {
                copied: false,
                copiedTimer: null
            }
        },
        computed: {
            feedUrl() {
                return `${process.env.VUE_APP_API_HOST_DOMAIN}/teams/${this.teamId}/calendar.ics`
            },
            // webcal:// makes the calendar apps subscribe instead of importing the events once
            webcalUrl() {
                return this.feedUrl.replace(/^https?:\/\//, 'webcal://')
            }
        },
        beforeDestroy() {
            clearTimeout(this.copiedTimer)
        },
        methods: {
            subscribeApple() {
                this.openExternal(this.webcalUrl)
            },
            subscribeGoogle() {
                this.openExternal(`https://calendar.google.com/calendar/r?cid=${encodeURIComponent(this.webcalUrl)}`)
            },
            copyLink() {
                const done = () => {
                    this.copied = true
                    clearTimeout(this.copiedTimer)
                    this.copiedTimer = setTimeout(() => {
                        this.copied = false
                    }, 2500)
                }
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(this.feedUrl).then(done).catch(() => window.prompt('Σύνδεσμος ημερολογίου', this.feedUrl))
                } else {
                    window.prompt('Σύνδεσμος ημερολογίου', this.feedUrl)
                }
            },
            openExternal(url) {
                // in the app '_system' hands the url to the OS (browser / calendar app)
                window.open(url, window.cordova ? '_system' : '_blank', 'noopener')
            }
        }
    }
</script>

<style scoped>
.team-calendar-btn {
    font-weight: 700;
    text-transform: none;
    letter-spacing: normal;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12) !important;
}

.team-calendar-menu__hint {
    height: auto;
    padding-top: 8px;
    padding-bottom: 4px;
    max-width: 280px;
    font-size: 0.75rem;
    line-height: 1.3;
}
</style>
